import questionsData from '../../shared/questions.json';
import type { Question, CategoryMeta, AnswerOption } from '../types';

// ── Category metadata (from shared JSON) ─────────────────────────

export const CATEGORIES: CategoryMeta[] = questionsData.categories as CategoryMeta[];

// ── Answer scale ───────────────────────────────────────────────────

export const ANSWER_OPTIONS: AnswerOption[] = [
  { value: 'dislike', emoji: '🚫', label: 'Pass',                    isPositive: false },
  { value: 'open',    emoji: '🤔', label: 'Curious',                 isPositive: true },
  { value: 'like',    emoji: '🥰', label: 'Yes please',              isPositive: true },
  { value: 'love',    emoji: '🔥', label: 'Hell yes!',               isPositive: true },
];

// ── All questions (from shared JSON) ──────────────────────────────

export const QUESTIONS: Question[] = questionsData.questions as Question[];
